@if (isAdmin$()) {
    <homeleite-admin-home></homeleite-admin-home>
} @else if (isController$()) {
    <homeleite-controller-page (logoutClick)="logout()"></homeleite-controller-page>
} @else {
    <homeleite-layout-base>
        <div actions>
            <button mat-icon-button (click)="logout()">
                <mat-icon>logout</mat-icon>
            </button>
        </div>
        <section class="nonAdminContent">
            <mat-card>
                <mat-card-header>
                    <mat-card-title> Acesse pelo nosso aplicativo</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="buttons">
                        <a
                            class="googlePlayBtn"
                            href="https://play.google.com/store/apps/details?id=io.esparta.apcbrh.parlpr&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                        ><img
                            alt="Disponível no Google Play"
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png"
                        /></a>
                        <a
                            href="https://apps.apple.com/br/app/home-leite/id1432591256?itsct=apps_box_badge&amp;itscg=30200"
                            class="appStoreBtn"
                        ><img
                            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pt-br?size=250x83&amp;releaseDate=1535846400&h=d796fd717aef7102f05719a4788f231e"
                            alt="Download on the App Store"
                        /></a>
                    </div>
                </mat-card-content>
            </mat-card>
        </section>
    </homeleite-layout-base>
}
